import mallActions from "./mallActions";
import mallGetters from "./mallGetters";
import mallMutations from "./mallMutations";
export default {
    state: {
        cartList: [],
    },
    mutations:mallMutations,
    actions:mallActions,
    getters:mallGetters,
}